import { defineStore } from 'pinia'
import { fetchBookingToken } from '../services/oauthService'

interface TokenInfo {
  token: string
  expirationTime: number
  type: 'public' | 'booking' | 'crm'
  bookingNumber?: string
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    currentToken: null as TokenInfo | null,
  }),
  getters: {
    token: (state) => state.currentToken?.token || null,
    tokenExpirationTime: (state) => state.currentToken?.expirationTime || null,
    isTokenValid: (state) => {
      if (!state.currentToken) return false
      return Date.now() < state.currentToken.expirationTime
    },
    isBookingToken: (state) => state.currentToken?.type === 'booking',
    isCrmToken: (state) => state.currentToken?.type === 'crm',
    currentBookingNumber: (state) => state.currentToken?.bookingNumber || null,
  },
  actions: {
    setToken(
      token: string,
      expirationTime: number,
      type: 'public' | 'booking' | 'crm' = 'public',
      bookingNumber?: string,
    ) {
      this.currentToken = {
        token,
        expirationTime,
        type,
        bookingNumber,
      }
    },
    setBookingTokenFromLocalStorage() {
      const token = localStorage.getItem('bookingToken')
      const bookingNumber = localStorage.getItem('pendingBookingNumber')
      if (token && bookingNumber) {
        const expirationTime = Date.now() + 3600000 // Token expires in 1 hour
        this.setToken(token, expirationTime, 'booking', bookingNumber)
      }
    },
    clearToken() {
      this.currentToken = null
    },
    async getBookingToken(bookingNumber: string, email: string): Promise<string> {
      try {
        const token = await fetchBookingToken(bookingNumber, email)
        // Set expiration to 20 minutes from now
        const expirationTime = Date.now() + 20 * 60 * 1000
        this.setToken(token, expirationTime, 'booking', bookingNumber)
        return token
      } catch (error) {
        console.error('Failed to get booking token:', error)
        throw error
      }
    },
  },
})
